import { ChangeEventHandler, useCallback } from "react";
import { Filter, RefreshCw } from "lucide-react";
import { SearchInput } from "components/common/SearchInput";
import { FilterPanelProps } from "./types";

export function FilterPanel<TStatus extends string>({
  searchTerm,
  onSearchChange,
  statusFilter,
  onStatusChange,
  statuses,
  onRefresh,
  className = "",
  searchPlaceholder,
  allStatusesLabel,
}: FilterPanelProps<TStatus>) {
  const handleStatusChange: ChangeEventHandler<HTMLSelectElement> = useCallback(
    (e) => {
      const selected = e.target.value;
      if (selected === "all" || statuses.some((s) => s.value === selected)) {
        onStatusChange(selected === "all" ? "all" : (selected as TStatus));
      }
    },
    [onStatusChange, statuses],
  );

  return (
    <div className={`${className}`}>
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1">
          <SearchInput
            value={searchTerm}
            onChange={onSearchChange}
            placeholder={searchPlaceholder}
          />
        </div>
        <div className="sm:w-48">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Filter className="h-5 w-5 text-gray-400" />
            </div>
            <select
              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              value={statusFilter}
              onChange={handleStatusChange}
            >
              <option value="all">{allStatusesLabel}</option>
              {statuses.map((status) => (
                <option key={status.value} value={status.value}>
                  {status.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <button
          onClick={onRefresh}
          className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          <RefreshCw className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
